import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import Text, { Label } from '../../../../../packages/kiti/components/presentation/Text'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import NumberInput from '../../../../../packages/kiti/components/form/NumberInput'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import CheckboxInput from '../../../../../components/form/CheckboxInput'
import FlexGrid, { FlexColumn } from '../../../../../components/structure/FlexGrid'
import { useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import UserSelect from '../../../../../containers/users/select/UserSelect'

const UserFilter = () => {
  const { form, handleChangeIn } = useFormState()
  const { t } = useTranslation('editServiceOrderAutomaticDistribution')

  return (
    <FlexGrid wrap justify="flex-start" align="flex-start" paddingGutter={0.4}>
      <Text>{t('filters.users.description')}</Text>
      <FlexColumn width="100%">
        <CheckboxInput
          label={t('filters.all_users')}
          value={form.value?.filters?.users?.type === 'all'}
          onChange={() => {
            handleChangeIn(['value', 'filters', 'users', 'type'], 'all')
            handleChangeIn(['value', 'filters', 'users', 'selected'], null)
          }}
        />
      </FlexColumn>
      <FlexColumn width="100%">
        <CheckboxInput
          label={t('filters.related_users')}
          value={form.value?.filters?.users?.type === 'related'}
          onChange={() => {
            handleChangeIn(['value', 'filters', 'users', 'type'], 'related')
            handleChangeIn(['value', 'filters', 'users', 'selected'], null)
          }}
        />
      </FlexColumn>
      <FlexColumn width="100%">
        <Grid gutter={0.3}>
          <Col justify={'center'} width="50%">
            <CheckboxInput
              label={t('filters.selected')}
              value={form.value?.filters?.users?.type === 'selected'}
              onChange={selected => {
                if (selected) {
                  handleChangeIn(['value', 'filters', 'users', 'type'], 'selected')
                }
              }}
            />
          </Col>
          <Col justify={'center'} width="50%">
            <FormItem
              path={['value', 'filters', 'users', 'selected']}
              multiple
              disabled={form.value?.filters?.users?.type !== 'selected'}
              Input={UserSelect}
            />
          </Col>
        </Grid>
      </FlexColumn>
    </FlexGrid>
  )
}

const DistanceFilter = () => {
  const { form, handleChangeIn } = useFormState()
  const { t } = useTranslation('editServiceOrderAutomaticDistribution')

  return (
    <FlexGrid wrap justify="flex-start" align="flex-start" paddingGutter={0.4}>
      <FlexColumn width="100%">
        <Text>{t('filters.distance.description')}</Text>
      </FlexColumn>
      <FlexColumn width="100%">
        <CheckboxInput
          label={t('filters.enable')}
          value={form.value?.filters?.distance}
          onChange={value => handleChangeIn(['value', 'filters', 'distance'], value)}
        />
      </FlexColumn>
      <FlexColumn width="50%">
        <Text noMargin>{t('distanceRadius')}</Text>
        <FormItem path={['value', 'distance_radius']} Input={NumberInput} disabled={!form.value?.filters?.distance} />
      </FlexColumn>
    </FlexGrid>
  )
}

const ScheduleFilter = () => {
  const { form, handleChangeIn } = useFormState()
  const { t } = useTranslation('editServiceOrderAutomaticDistribution')

  return (
    <FlexGrid wrap justify="flex-start" align="flex-start" paddingGutter={0.4}>
      <Text>{t('filters.schedule.description')}</Text>
      <CheckboxInput
        label={t('filters.enable')}
        value={form.value?.filters?.schedule}
        onChange={value => handleChangeIn(['value', 'filters', 'schedule'], value)}
      />
    </FlexGrid>
  )
}

const GeneralSection = () => {
  const { t } = useTranslation('editServiceOrderAutomaticDistribution')
  return (
    <>
      <Grid paddingGutter={0.2} wrap>
        <Text size="h5" marginBottom={0.4} bold>
          {t('filters')}
        </Text>
        <Col width="100%">
          <Label noMargin>{t('filters.users')}</Label>
          <FormItem path={['value', 'filters']} Input={UserFilter} />
        </Col>
        <Separator weight={2} />
        <Col width="100%">
          <Label noMargin>{t('filters.distance')}</Label>
          <FormItem path={['value', 'filters']} Input={DistanceFilter} />
        </Col>
        <Separator weight={1} />
        <Col width="100%">
          <Label noMargin>{t('filters.schedule')}</Label>
          <FormItem path={['value', 'filters']} Input={ScheduleFilter} />
        </Col>
        <Separator weight={1} />
      </Grid>
      <LineSeparator />
      <Text size="h5" marginBottom={0.4} bold>
        {t('generalConfig')}
      </Text>
      <Grid paddingGutter={0.2} wrap>
        <Text>{t('generalConfig.daysLimit.description')}</Text>
        <Col width="50%">
          <Label noMargin>{t('generalConfig.daysLimit')}</Label>
          <FormItem path={['value', 'days_limit']} Input={NumberInput} min={1} />
        </Col>
      </Grid>
    </>
  )
}

export default GeneralSection
